import { Component, OnInit, Input } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';

@Component({
  selector: 'app-logo-render',
  templateUrl: './logo-render.component.html',
  styleUrls: ['./logo-render.component.css']
})
export class LogoRenderComponent implements ViewCell, OnInit {

  url: string;
  tenen: boolean;

  @Input() value: any;
  @Input() rowData: any;

  ngOnInit() {
    if (this.value) {
      this.url = 'https://era.esplac.cat/files/' + this.value["path"] + '/' + this.value["nom"];
      this.tenen = true;
    } else { this.tenen = false; }
  }

}
